import { Checkbox } from 'components/Form/SelectCards/components/Checkbox';
import { getAriaLabel } from 'components/Form/SelectCards/components/getAriaLabel';
import { Radio } from 'components/Form/SelectCards/components/Radio';
import { SelectCardLayout } from 'components/Form/SelectCards/SelectCardLayout';
import { Option, Size, Variant } from 'components/Form/SelectCards/types';
import React, { useId } from 'react';
import 'twin.macro';
import tw, { TwStyle } from 'twin.macro';

interface Props<T> {
  id?: string;
  option: Option<T>;
  checked?: boolean;
  isMulti?: boolean;
  onChange: (checked: boolean) => void;
  size?: Size;
  variant?: Variant;
}
const SIZE_STYLES: Record<Size, TwStyle> = {
  'extra-small': tw`text-sm font-normal`,
  small: tw`text-base`,
  big: tw`text-base`,
};

export function SelectCard<T>({
  id,
  checked,
  onChange,
  option,
  variant = 'filled',
  size = 'small',
  isMulti,
}: Props<T>) {
  const reactId = useId();
  const inputId = id ?? `checkbox-${reactId}`;
  const sizeStyles = SIZE_STYLES[size];
  const { label, description, illustration } = option;

  const icon = isMulti ? (
    <Checkbox
      checked={checked}
      onChange={onChange}
      size={size}
      id={inputId}
      option={option}
      ariaLabel={getAriaLabel(option)}
    />
  ) : (
    <Radio
      checked={checked}
      onChange={onChange}
      size={size}
      id={inputId}
      option={option}
      ariaLabel={getAriaLabel(option)}
    />
  );

  return (
    <SelectCardLayout
      checked={checked}
      size={size}
      variant={variant}
      id={inputId}
      illustration={illustration}
      icon={icon}
      label={
        label && (
          <div
            css={[
              tw`font-semibold text-neutral-moderate`,
              sizeStyles,
              checked && tw`text-brand-intense`,
            ]}
          >
            {label}
          </div>
        )
      }
      description={
        description && (
          <div
            css={[
              tw`text-neutral-moderate`,
              sizeStyles,
              checked && tw`text-brand-moderate`,
            ]}
          >
            {description}
          </div>
        )
      }
    />
  );
}
